(function() {
	'use strict';

	var originalPcRow, originalParent, originalNextSibling;

	function cachePcRow() {
		if (!originalPcRow) {
			var pcRow = document.querySelector('.tr.content-tr.js-pc');
			if (pcRow) {
				originalPcRow = pcRow.cloneNode(true);
				originalParent = pcRow.parentNode;
				originalNextSibling = pcRow.nextSibling;
			}
		}
	}

	function updatePcRowVisibility() {
		var hashMatch = window.location.hash.match(/#(pc|mac|ios|android)/);
		var platform = hashMatch ? hashMatch[1] : null;
		var pcRow = document.querySelector('.tr.content-tr.js-pc');

		if (platform && platform !== 'pc') {
			if (pcRow && pcRow.parentNode) {
				pcRow.parentNode.removeChild(pcRow);
			}
		} else if (platform === 'pc') {
			if (!pcRow && originalPcRow && originalParent) {
				var newRow = originalPcRow.cloneNode(true);
				if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
					originalParent.insertBefore(newRow, originalNextSibling);
				} else {
					originalParent.appendChild(newRow);
				}
			}
		}
	}

	function onReady() {
		cachePcRow();
		updatePcRowVisibility();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', onReady);
	} else {
		onReady();
	}

	window.addEventListener('hashchange', function() {
		updatePcRowVisibility();
	});

})();

